import { of as observableOf, Observable } from 'rxjs';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../utils/froala.utils';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from "@angular/forms";
import { WorkOrderWithAssignments, WorkOrder, WorkOrderType } from '../../models/work-order.model';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { SubHeader } from '../../../core/models/sub-header.model';
import { DateService } from '../../services/date.service';
import { ContactService } from '../../../admin/services/contacts.service';
import { AssigneeType, Assignee } from '../../models/assignee.model';
import { WorkOrderService } from '../../services/work-order.service';
import { genId } from '../../../core/services/genId';
import { LoaderService } from '../../services/loader.service';
import { Contact } from '../../../admin/models/contact.model';
import { GroupStub } from '../../../admin/models/group.model';
import { GroupService } from '../../../admin/services/group.service';
import { AuthService } from '../../../services/auth.service';
import { UserIdentity } from '../../../models/user-identity.model';

@Component({
    selector: 'app-work-order',
    templateUrl: './work-order.component.html',
    styleUrls: ['./work-order.component.scss'],
    standalone: false
})

export class WorkOrderComponent implements OnInit {

  currentAssignee: Assignee = new Assignee('', '', null, '');
  currentDate: Date = new Date();
  currentDay: any = this.currentDate.getUTCDate();
  currentMonth: any = this.currentDate.getUTCMonth() + 1; //months from 1-12
  currentYear: any = this.currentDate.getUTCFullYear();

    private _froalaOptions: any = null;
    get froalaOptions(): Object {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                height: 500,
                heightMin: 150,
                placeholderText: 'Type Something',
                key: key,
                toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'color']
            });
        }
        return this._froalaOptions;
  };


  noAssigneeSearchResults: boolean = false;
  placeholder: string = DateService.DatePickerFormat;
  queryField: AbstractControl;
  searchResults: GroupStub[] | Contact[] = [];
  selectedDate: Date = new Date();
  showDropDown: boolean = false;

  subHeader: SubHeader = new SubHeader({
    title: "Manage Groups",
    buttons: [{ name: "Cancel", method: () => this.cancel() }, { name: "Save", method: () => this.save() }]
  });

  user: UserIdentity;
  viewOnly: boolean = false;
  workOrder: WorkOrderWithAssignments;
  workOrderForm: FormGroup;

  constructor(public authService: AuthService,
    public route: ActivatedRoute,
    public location: Location,
    public formBuilder: FormBuilder,
    public subHeaderService: SubHeaderService,
    public dateService: DateService,
    public contactService: ContactService,
    public groupService: GroupService,
    public workOrderService: WorkOrderService,
    public loader: LoaderService
  ) { }

  ngOnInit() {

    this.workOrder = this.route.snapshot.data.workOrder;
    this.constructForm();
    this.user = this.authService.User;

    if (!this.workOrder) {

      this.workOrder = new WorkOrderWithAssignments();
      this.subHeader.title = 'Add Work Order';
      this.workOrderForm.get('assignee').disable();

    } else {

      // This needs re-thought
      // this.viewOnly = this.workOrder.creatorId !== this.user.id;
      // this.disableControls(this.viewOnly);

      if (this.viewOnly) {
        this.subHeader.title = 'View Work Order';
        this.subHeader.buttons = [{ name: "Cancel", method: () => this.cancel() }];
      } else {
        this.subHeader.title = 'Edit Work Order';
      };

      this.selectedDate = this.workOrder.dueDate ? new Date(this.workOrder.dueDate) : new Date();
      this.workOrderForm.patchValue({ dueDate: this.selectedDate });
      this.setAssignee();

    };

    this.subHeaderService.updateSubHeader(this.subHeader);
    this.queryField = this.workOrderForm.get('assignee');

    this.queryField.valueChanges.pipe(debounceTime(500), distinctUntilChanged(), switchMap((query: string): Observable<Contact[]> | Observable<GroupStub[]> => {

        if (!query.length) return observableOf([]);

        document.body.style.cursor = 'wait';

        if (this.currentAssignee.type == AssigneeType.Group) {
          return (this.groupService.get({ stubs: true, contains: query }) as Observable<GroupStub[]>);
        }
        else {
            return (this.contactService.getAll<Contact[]>({ stubs: true, contains: query, internal: true}));
        }
      }))
      .subscribe(response => {
        this.searchResults = response;
        document.body.style.cursor = 'default';
        this.noAssigneeSearchResults = (!this.searchResults.length && this.workOrderForm.controls['assignee'].value);
      });

    this.loader.toggleLoader(false);
  }

  assigneeSelected(assignee: any) {
    this.currentAssignee = new Assignee(assignee.displayName, assignee.id, this.getAssigneeType(), assignee.organizationId);
    this.workOrderForm.controls['assignee'].setValue(assignee.displayName, { emitEvent: false });
    this.noAssigneeSearchResults = false;
  }

  buildWorkOrderFromForm(): void {

    this.workOrder.creatorId = this.user.id;
    this.workOrder.title = this.workOrderForm.controls['title'].value;
    this.workOrder.description = stripFroalaWatermark(this.workOrderForm.controls['description'].value);
    this.workOrder.dueDate = this.selectedDate.toUTCString();
    this.workOrder.targetUrl = this.workOrderForm.controls['link'].value;
    this.workOrder.id = this.workOrder.id ? this.workOrder.id : genId();
      this.workOrder.organizationId = this.workOrderForm.controls['organizationId'].value;

    switch (this.currentAssignee.type) {
      case AssigneeType.Group: {
        this.workOrder.assignedUserId = null;
        this.workOrder.assignedGroupId = this.currentAssignee.id;
        //this.workOrder.organizationId = null;
        break;
      }
      case AssigneeType.Organization: {
        // TODO: Implement Organization
        // workOrder.assignedGroupId = this.currentAssignee.id;
        break;
      }
      case AssigneeType.User: {
        this.workOrder.assignedUserId = this.currentAssignee.id;
        this.workOrder.assignedGroupId = null;
        //this.workOrder.organizationId = this.currentAssignee.organizationId;
        break;
      }
    }

  }

  cancel(): void {
    this.loader.toggleLoader(true);
    this.location.back();
  }

  constructForm(): void {

    const description = this.workOrder ? this.workOrder.description : '';

    this.workOrderForm = this.formBuilder.group({
      title: ["", Validators.required],
      assigneeType: ["", Validators.required],
      assignee: ["", Validators.required],
      dueDate: this.formBuilder.group({ value: this.selectedDate, disabled: false}, [Validators.required]),
      organizationId: [""],
      link: [""],
      description: [description, Validators.required]
    });
  }

  dateChange(e: Date): void {
    this.selectedDate = e;
  }

  disableControls(disable: boolean): void {
    if (disable) {
      Object.keys(this.workOrderForm.controls).forEach(key => {
        this.workOrderForm.get(key).disable();
      });
    }
  }

  getAssigneeType(): AssigneeType {
    const radio = this.workOrderForm.get('assigneeType');
    switch (radio.value) {
      case 'group': {
        return AssigneeType.Group
      }
      case 'user': {
        return AssigneeType.User
      }
    }
  }

  getUserDisplayName(assignee: any): string {
    return assignee.firstName + ' ' + assignee.lastName;
  }

  radioChanged(e) {
    this.workOrderForm.patchValue({ assignee: '' });
    this.currentAssignee.type = this.getAssigneeType();
    this.queryField.enable();
  }

  save(): void {

    if (this.workOrderForm.invalid) {
      // Touch all the controls to reveal validation errors
      Object.keys(this.workOrderForm.controls).forEach(field => {
        const control = this.workOrderForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });

      return;
    }

    this.loader.toggleLoader(true);
    this.buildWorkOrderFromForm();

    this.workOrderService.save(this.workOrder).subscribe(response => {
      this.location.back();
    });

  }

  searchEnter(): void {
    this.workOrderForm.patchValue({ assignee: '' });
    this.showDropDown = true;
  }

  searchLeave(): void {
    this.workOrderForm.controls['assignee'].setValue(this.currentAssignee.displayName, { emitEvent: false });
    this.showDropDown = false;
    this.noAssigneeSearchResults = false;
  }

  setAssignee(): void {

    if (this.workOrder.assignedUserId) {
      this.currentAssignee = new Assignee(this.getUserDisplayName(this.workOrder.assignee), this.workOrder.assignedUserId, AssigneeType.User, this.currentAssignee.organizationId)
    } else if (this.workOrder.assignedGroupId) {
      this.currentAssignee = new Assignee(this.workOrder.assignedGroup.displayName, this.workOrder.assignedGroupId, AssigneeType.Group, this.currentAssignee.organizationId)
    };

    this.workOrderForm.controls['assignee'].setValue(this.currentAssignee.displayName, { emitEvent: false });
    this.workOrderForm.patchValue({ assigneeType: AssigneeType[this.currentAssignee.type].toLowerCase() })
  }

}
